/**
 * useGoogleMaps — loads the Google Maps JS SDK once (idempotent).
 * Returns { loaded, error }
 */
import { useState, useEffect } from 'react';

const SCRIPT_ID = 'google-maps-sdk';
const API_KEY   = process.env.REACT_APP_GOOGLE_MAPS_KEY;

let _loaded = false;
let _callbacks = [];

function onLoad() {
  _loaded = true;
  _callbacks.forEach(fn => fn());
  _callbacks = [];
}

export default function useGoogleMaps() {
  const [loaded, setLoaded] = useState(_loaded);
  const [error,  setError]  = useState(false);

  useEffect(() => {
    if (_loaded) { setLoaded(true); return; }
    if (document.getElementById(SCRIPT_ID)) {
      _callbacks.push(() => setLoaded(true));
      return;
    }

    window.__googleMapsInit = onLoad;
    const script = document.createElement('script');
    script.id    = SCRIPT_ID;
    script.src   = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&language=ar&callback=__googleMapsInit`;
    script.async = true;
    script.defer = true;
    script.onerror = () => setError(true);
    _callbacks.push(() => setLoaded(true));
    document.head.appendChild(script);
  }, []);

  return { loaded, error };
}
